export default __webpack_public_path__ + "static/media/exr-pilot-serf.6d93a8ac.jpg";